import { render, staticRenderFns } from "./link-group.vue?vue&type=template&id=69a351ca&"
import script from "./link-group.vue?vue&type=script&lang=js&"
export * from "./link-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports